import script from "./ModelManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelManagement.vue?vue&type=script&setup=true&lang=js"

import "./ModelManagement.vue?vue&type=style&index=0&id=185c0d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-185c0d98"]])

export default __exports__